import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/**
 * Component store for the conversation selector.
 *
 * Responsible for presenting the sibling users available in the current app
 * context for sharing.
 *
 * TODO: Any logic that is shared across the conversation selector and its child
 * components (conversation-item, workspace-item, workspace-tree) should be
 * moved here.
 */
@ngCore.Injectable()
export class Store {
  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /**
   * The ID of the currently logged-in user.
   */
  public readonly currentUserId = ngCore.computed(() =>
    this._meFeature.selectors.currentUserId.asSignal(),
  )

  /**
   * A list of user items for the "Share with" multi-select. Excludes the
   * currently logged-in user and gates the list on an active app context being
   * present.
   */
  public readonly userItems = ngCore.computed<
    readonly ds.input.select.models.Item<ents.core.admin.User.Id>[]
  >(
    (
      appContext = this._meFeature.contexts.selectors.appContext.asSignal(),
      users = this._meFeature.siblingUsers.selectors.users.asSignal() ?? [],
    ) =>
      appContext
        ? users
            .filter(user => user.id !== this.currentUserId())

            .map(user => ({
              label: user.name ?? 'Unknown User',
              value: user.id,
            }))
        : [],
  )
}
